export const SAVE_ACCESS_KEY = "SAVE_ACCESS_KEY";
export const SAVE_PRODUCT_PAYLOAD = "SAVE_PRODUCT_PAYLOAD";


// WEBPACK FOOTER //
// ./modules/access-key-processor/actions/actionTypes.ts